import { CLIMATIC_SET_MODE_FOR_CIRCUIT } from './actions';
export const climatic_mode_loading_reducer = (state = {}, action) => {
    switch (action.type) {
        case CLIMATIC_SET_MODE_FOR_CIRCUIT: {
            const a = action;
            return {
                ...state,
                [a.device_id]: {
                    ...state[a.device_id],
                    [a.circuit_id]: true,
                },
            };
        }
        case 'APPLY_IO_PORTS': {
            let new_state = state;
            for (const [device_id, setter] of Object.entries(action.devid2setter)) {
                if ('z3k_state' in setter) {
                    const new_dev_state = new_state[~~device_id];
                    if (new_dev_state != null && setter['z3k_state'] != null) {
                        for (const object_id of Object.keys(setter['z3k_state'])) {
                            new_dev_state[~~object_id] = false;
                        }
                        new_state = { ...new_state, [device_id]: new_dev_state };
                    }
                }
            }
            return new_state;
        }
        default:
            return state;
    }
};
